import { render, staticRenderFns } from "./PaymentsHome.vue?vue&type=template&id=884ea1e6&scoped=true"
import script from "./PaymentsHome.vue?vue&type=script&lang=js"
export * from "./PaymentsHome.vue?vue&type=script&lang=js"
import style0 from "./PaymentsHome.vue?vue&type=style&index=0&id=884ea1e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884ea1e6",
  null
  
)

export default component.exports